import { useWizardStore } from '../store/wizardStore';
import { StepShell } from '../components/StepShell';
import { Button } from '../components/ui/Button';
import { FileUpload } from '../components/ui/FileUpload';
import { MAX_INSERTS } from '../types/wizard.types';

export function Step5_Insert() {
  const inserts = useWizardStore((s) => s.inserts);
  const addInsert = useWizardStore((s) => s.addInsert);
  const removeInsert = useWizardStore((s) => s.removeInsert);
  const goTo = useWizardStore((s) => s.goTo);

  const canAddMore = inserts.length < MAX_INSERTS;

  const hasInserts = inserts.length > 0;

  return (
    <StepShell
      title="Прикрепить вставку (расчёт/спецификация)"
      subtitle={`Файлы из офиса (PDF, DOCX, XLS/XLSX) — до 10 МБ каждый, до ${MAX_INSERTS} файлов. Обязательно прикрепите хотя бы один файл.`}
      current="insert"
      footer={
        <div className="flex justify-between items-center gap-4">
          <Button variant="secondary" onClick={() => goTo('signatures')}>Назад</Button>
          <div className="flex flex-col items-end gap-2">
            {!hasInserts && (
              <p className="text-sm text-amber-600">Без приложения отправка договора невозможна</p>
            )}
            <Button onClick={() => goTo('summary')} disabled={!hasInserts}>
              Далее — Итог →
            </Button>
          </div>
        </div>
      }
    >
      <div className="bg-white rounded-xl border p-6 max-w-xl">
        {inserts.length > 0 && (
          <ul className="mb-4 space-y-2">
            {inserts.map((file, i) => (
              <li
                key={`${file.name}-${i}`}
                className="flex items-center justify-between rounded-lg border px-3 py-2"
              >
                <div className="text-sm min-w-0">
                  <div className="font-medium truncate">{file.name}</div>
                  <div className="text-slate-500">Прикреплено</div>
                </div>
                <Button variant="secondary" onClick={() => removeInsert(i)}>
                  Удалить
                </Button>
              </li>
            ))}
          </ul>
        )}

        {canAddMore ? (
          <FileUpload
            currentName={null}
            onFile={(name, base64) => addInsert({ name, base64 })}
          />
        ) : (
          <p className="text-sm text-slate-500">
            Прикреплено максимальное число файлов ({MAX_INSERTS}).
          </p>
        )}

        <p className="mt-2 text-sm text-slate-400">
          Прикреплено: {inserts.length} из {MAX_INSERTS}
        </p>
      </div>
    </StepShell>
  );
}
